<template>
  <kst-page-list
    :catalog="SearchCatalog"
    :params="Model.Search.ListParams"
    :search="searchData"
    @init="handleInit"
    @load="handleLoad"
    @reset="handleReset"
  >
    <template #search="{ handleInput }">
      <Search
        :searchData="searchData"
        :cashierOptions="cashierOptions"
        :warehouseOptions="warehouseOptions"
        @input="handleInput"
      />
    </template>

    <template #search-result="{ data }">
      <List 
        :access="access"
        :dataList="data.List"
      />
    </template>
  </kst-page-list>
</template>

<script>
import SearchCatalog from "./SearchCatalog.js";
import Model from "../SlrcModel.js";
import Services from "../../../services/Api/SalesRecapServices.js";

import List from "./SlrcL_List.vue";
import Search from "./SlrcL_Search.vue";

export default {
  components: {
    List,
    Search
  },
  data: () => ({
    Model: Model,
    SearchCatalog: SearchCatalog,
    access: {},
    searchData: {
      Search:"",
      CashierID: null, 
      Date: null,
      WarehouseID: null
    },
    cashierOptions: {},
    warehouseOptions: {}
  }),
  created() {
    this.resetSearch();
  },
  methods: {
    /*** by page ***/

    handleInit(loadListData) {
      this.resetData();

      const options = this.getListOptions();
      const config = Services.getListData(options); 
      loadListData(config, this.handleInit_Success);
    },
    handleInit_Success(data) {
      this.cashierOptions = Model.getCashierOptions(
        data.CashierList, SearchCatalog.CashierID.Label
      );
      this.warehouseOptions = Model.getWarehouseOptions(
        data.WarehouseList, SearchCatalog.WarehouseID.Label
      );
    },

    handleLoad(loadList) {
      const options = this.getListOptions();
      const config = Services.getList(options);
      loadList(config);
    },

    handleReset() {
      this.resetSearch();
    },

    /*** custom ***/

    resetData() {
      this.access = this.$kst.Access.create(Model.Access);
      this.cashierOptions = {};
      this.warehouseOptions = {};

      this.normalizeSearch();
    },

    normalizeSearch() {
      if (this.searchData.WarehouseID === null) {
        this.searchData.WarehouseID = this.$kst.Session.getDefaultWarehouseID();
      }
    },

    resetSearch() {
      this.searchData.Search = "";
      this.searchData.CashierID = this.$kst.Search.OptionAll;
      this.searchData.Date = this.$kst.In.getDefaultDateRange();
      this.searchData.WarehouseID = this.$kst.Session.getDefaultWarehouseID();
    },

    getListOptions() {
      return {
        startdate: this.$kst.Out.getDateString(this.searchData.Date[0]),
        enddate: this.$kst.Out.getDateString(this.searchData.Date[1]),
        cashier: this.$kst.Search.getValue(this.searchData.CashierID),
        warehouse: this.$kst.Search.getValue(this.searchData.WarehouseID),
        field: Model.Search.Fields,
        search: this.$kst.Out.getString(this.searchData.Search)
      };
    }
  }
}
</script>